// @i18n-ignore-file
export const LB_USER_ID_HEADER = 'x-lb-user-id'
export const REGION_ID_HEADER = 'x-gctx-request-origin-region-id'
export const REGION_LANG_HEADER = 'x-gctx-request-origin-locale'
export const CANARY_GROUP_ID_HEADER = 'x-gctx-canary-group-id'
export const COUNTRY_HEADER = 'cloudfront-viewer-country'
export const STORE_PROGRAM_ID_HEADER = 'x-store-program-id'
export const VELOU_FILTERS_HEADER = 'x-show-dynamic-filters'
export const SUBSCRIPTION_EXP_ENABLED_HEADER = 'x-exp-subscription-enabled'
export const PERSONALISATION_ENABLED_HEADER = 'x-personalisation-enabled'

// Which tier of `resolvePLRegionAndLocale` produced the region/locale pair on this PL request
// (`cookie` | `server_locale` | `default` | `b2b`). Diagnostic only — PL ignores it.
//
// It rides as a header rather than a RUM action because the population that needs measuring is
// mostly crawlers: RUM samples sessions and filters bots, whereas PL records the whole request
// header blob on its controller spans, so this is queryable for every request including Googlebot's.
// Read alongside `error.message` to see which resolution tier each rejected pair came from.
export const REGION_SOURCE_HEADER = 'x-quince-region-source'

// SVD: opt-in for SVD-shaped product cards on the BFF **page-data** homepage (storefront-bff #1151).
// Same constant name as the BFF side (`src/constants/headers.ts`), since it is one contract.
//
// Honoured only when the request is ALSO on v4, and only for the HOME template; BFF appends an `_svd`
// suffix to its cache key when it takes effect. Sent exclusively from `getHomepagePageDataBFF` — see
// the note there for why it must not ride along on every v4 page-data request.
//
// Not to be confused with `ENRICH_VERSION_HEADER` below: that one is the PRESENTATION-LAYER
// (`layouts/fetch` / `widgets/fetch`) SVD opt-in. Different upstream, different contract.
export const ENABLE_SVD_CARDS_HEADER = 'x-enable-svd-cards'

// PL layout-fetch enrichment version. `V2` = the SVD/VDA-native enrichment (emits PRODUCT_PURCHASE_V2 &
// friends), sent only behind the SVD flag. There is deliberately NO `V1` value: PL's legacy enrichment is
// what an ABSENT header selects, so a non-SVD session omits the header entirely (see `buildPLHeaders`).
export const ENRICH_VERSION_HEADER = 'x-enrich-version'
export const ENRICH_VERSION_VALUES = {
  V2: 'V2',
} as const

export const CONTENT_TYPE_HEADER = 'Content-Type'
export const XML_CONTENT_TYPE = 'text/xml'
export const JSON_CONTENT_TYPE = 'application/json; charset=utf-8'

export const B2B_TENANT_HEADER = 'x-b2b-tenant' // eslint-disable-line
export const B2B_PROGRAM_HEADER = 'x-b2b-program' // eslint-disable-line
export const B2B_FEATURE_PREVIEW_HEADER = 'xq-original-host' // eslint-disable-line
